import { Component, OnInit, EventEmitter, Input, OnDestroy, Output, ViewEncapsulation, TemplateRef, ViewChild } from "@angular/core";
import { IUserAccount, Page, IResource, ProgressData } from "@shared/models";
import { AppData, HttpService, NotifyService, ResourceService } from "@shared/services";
import { takeUntil, finalize } from "rxjs/operators";
import { LabParameterInputModel, LabComponentHeaderForInput, LabParameterInputHeaderModel, LabTransferModel, LabStatusModel, LabParameterGroup, LabTemplateHeaderForInput, LabBillDetailModel } from "@admin/labs/pages/models";
import { ApiResources, UtilHelper, LinqHelper } from "@shared/helpers";
import { forkJoin } from "rxjs";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import moment from "moment";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ProviderSpecialization } from "../../entities/provider-specialization.entity";
import { LabReportSignature } from "../../../areas/admin/labs/pages/models/lab-report-signature";
import { DomSanitizer } from "@angular/platform-browser";
import { LabObservedValueModel } from "../../../areas/admin/labs/pages/models/lab-observedValue.model";
import { HttpErrorResponse } from "@angular/common/http";

class TemplateInput {
    newLabBookingDetailId: number;
    labTemplateObservedValueId: number;
    labTemplateHeaderId: number;
    isMethod: boolean;
    methodText: string;
    isInterpretation: boolean;
    interpretationText: string;
    labMainDetailId: number;
}

class Age {
    year: number;
    month: number;
    day: number;
}


class TempParameter {
    labParameterObservedValueId?: number;
    labComponentHeaderId: number;
    componentName: string;
    labTemplateHeaderId: number;
    templateName: string;
    labParameterHeaderId: number;
    parameterName: string;
    displayName: string;
    referenceOutput: string;
    observedValue: string;
    templateCount: number;
    componentCount: number;
    labParameterDetailId?: number;
}

@Component({
    templateUrl: "./new-lab-parameter.html",
    selector: "new-lab-parameter",
    encapsulation: ViewEncapsulation.None
})

export class NewLabParameterWidget implements OnInit, OnDestroy {
    @ViewChild("#templateReport", { static: true }) templateReport: TemplateRef<any>;
    @Input() newLabBookingDetailId: number;
    @Output() onClose = new EventEmitter<any>();
    page: Page;
    loading: boolean;
    parameters: LabParameterInputModel;
    reports: LabParameterInputModel;
    submitting: boolean;
    submitted: boolean;
    templateInput: Array<TemplateInput>;
    parameterInput: Array<TempParameter>;
    loadingSample: boolean;
    demographData: Array<LabTransferModel>;

    loadingTimeline: boolean;
    timeline: Array<LabStatusModel>;

    modalRef: NgbModalRef;
    selectedParameter: LabParameterInputHeaderModel
    currentDate: Date;
    notesEditor = ClassicEditor;
    config = {
        placeholder: "Enter your content here!",
        toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote"]
    };
    age: Age;
    loadingProviders: boolean;
    providers: Array<IResource>;
    //provider: IResource;
    providerAssigningForm: FormGroup;
    providerSpecialization: Array<ProviderSpecialization>;
    reportSignatures: Array<LabReportSignature>;
    loadingDoctorSignatures: boolean;
    provideredit: boolean ;
    providerAssigned: Array<LabReportSignature>;
    loadingproviderAssigning: boolean;
    sendpatientId: string;
    doctorDropDown: boolean;
    loadingObservedValues: boolean;
    totalObservedValues: Array<LabObservedValueModel>;
    totalObservedValues2: any;
    parameterNames: any;
    showLabReport: boolean;
    fileUploadFail: boolean;
    loadingFile: boolean;
    uploadedFile: File;
    fileName: string;
    formedUrl: any;
    documentError: boolean;
    selectedLabBookingDetail: LabBillDetailModel;
    isUploading: boolean;
    techForm: FormGroup;
    isVerify: boolean;
    doctorAssigned: boolean ;
    constructor(
        private readonly appData: AppData,
        private readonly httpService: HttpService,
        private readonly modalService: NgbModal,
        private readonly notifyService: NotifyService,
        private readonly resourceService: ResourceService,
        private readonly formBuilder: FormBuilder,
        private readonly sanitizer: DomSanitizer,
        //private readonly router: Router,
    ) {
        this.page = new Page();
        this.doctorAssigned = false;
        this.doctorDropDown = false;
        this.provideredit = false;
        this.parameters = new LabParameterInputModel();
        this.templateInput = new Array<TemplateInput>();
        this.demographData = new Array<LabTransferModel>();
        this.timeline = new Array<LabStatusModel>();
        this.selectedParameter = new LabParameterInputHeaderModel();
        this.age = new Age();
        this.providers = new Array<IResource>();
        this.buildProviderAssigningForm();
        this.providerSpecialization = new Array<ProviderSpecialization>();
        this.reportSignatures = new Array<LabReportSignature>();
        this.totalObservedValues = new Array<LabObservedValueModel>();
        this.reports = new LabParameterInputModel();
        this.showLabReport = false;
        this.selectedLabBookingDetail = new LabBillDetailModel();
    }

    safe = (url: any) => {
        if (url) {
            return this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/png;base64, ${url}`);
        }
    }
    onCloseModel() {
        this.onClose.emit();
    }

    private onFetchDemographData() {
        this.loadingSample = true;
        const request = {
            newLabBookingDetailId: this.newLabBookingDetailId
        };
        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchReceivedLabs), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingSample = false))
            .subscribe((response: Array<LabTransferModel>) => {
                this.demographData = response;
                this.sendpatientId = this.demographData[0].encryptedId;
                if (UtilHelper.isEmpty(this.demographData[0].dateOfBirth)) {
                    let mdob = moment(this.demographData[0].dateOfBirth, "YYYY-MM-DD");
                    let age = moment().diff(mdob, "months");
                    let yrs = (age / 12).toFixed(1);
                    let months = age % 12;
                    let days = moment().diff(mdob.add(yrs, 'years'), 'days', false);
                    this.age.day = days;
                    this.age.year = parseInt(yrs, 10);
                    this.age.month = months;
                    let date1 = moment(this.demographData[0].dateOfBirth, "YYYY-MM-DD");
                    let monthsa = moment().diff(date1, 'months');
                    date1.add(monthsa, 'months');
                    let daysa = moment().diff(date1, 'days');
                    monthsa + ' ' + 'Month(s)' + ' ' + daysa + " Day(s)"
                    this.age.day = daysa;
                } else {
                    this.age = new Age();
                }
            });
    }

    private onFetchInputParameters() {
        const request = {
            newLabBookingDetailId: this.newLabBookingDetailId,
            fromTech:"tech"
        };
        this.loading = true;
        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.labParameterForInput), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: LabParameterInputModel) => {
                this.parameters = response;
                this.reports = new LabParameterInputModel();
                this.reports = UtilHelper.clone(this.parameters);
                this.reports.templates = new Array<LabTemplateHeaderForInput>();
                this.parameters.templates.forEach((template: LabTemplateHeaderForInput) => {
                    let parameterList = new Array<LabParameterInputHeaderModel>();
                    template.components.forEach((component: LabComponentHeaderForInput) => {
                        component.parameters.forEach((param: LabParameterInputHeaderModel) => {
                            let observedValue = +param.observedValue;
                            let range = param.selected;
                            if (range != null) {
                                let exactRange = range;
                                if (exactRange.minValue > observedValue) {
                                    param.showText = "L";
                                    param.isBold = true;
                                }
                                else if (observedValue > +exactRange.maxValue) {
                                    param.showText = "H";
                                    param.isBold = true;
                                }
                            }

                            parameterList.push(param);
                        });
                    });
                    template.parameters.forEach((param: LabParameterInputHeaderModel) => {
                        let observedValue = +param.observedValue;
                        let range = param.selected;
                        if (range != null) {
                            let exactRange = range;
                            if (exactRange.minValue > observedValue) {
                                param.showText = "L";
                                param.isBold = true;
                            }
                            else if (observedValue > +exactRange.maxValue) {
                                param.showText = "H";
                                param.isBold = true;
                            }
                        }
                        parameterList.push(param);
                    });
                    let templateToAssign = UtilHelper.clone(template) as LabTemplateHeaderForInput;

                    templateToAssign.components = new Array<LabComponentHeaderForInput>();
                    templateToAssign.parameters = new Array<LabParameterInputHeaderModel>();
                    LinqHelper.sort(parameterList, "displayOrder");
                    templateToAssign.parameters = parameterList;
                    this.reports.templates.push(templateToAssign);
                });
            });
    }

    onSubmit() {
        const BreakError = {};
        const req2 = {
            newLabBookingDetailId: this.newLabBookingDetailId,
        };
        //if (this.page.userAccount.roleId == 3) {
        //    req2["doctorId"] = this.page.userAccount.referenceId;
        //    req2["accountId"] = this.page.userAccount.accountId;
        //}
        req2["patientId"] = this.demographData[0].patientId;
        req2["urlLink"] = window.location.href;
        req2["testName"] = this.demographData[0].testName;
        try {

            const templates = this.parameters.templates;
            this.parameterInput = new Array<TempParameter>();
            this.templateInput = new Array<TemplateInput>();
            templates.forEach((template) => {
                if (template.isMethod) {
                    if (UtilHelper.isEmpty(template.methodText) && UtilHelper.isEmpty(template.methodText.trim())) {
                        // ignore
                    } else {
                        this.notifyService.warning(`Please enter method text for template ${template.templateName}`);
                        throw BreakError;
                    }
                }
                if (template.isInterpretation && !UtilHelper.isEmpty(template.interpretationText)) {
                    if (UtilHelper.isEmpty(template.interpretationText) && UtilHelper.isEmpty(template.interpretationText.trim())) {
                        // ignore
                    } else {
                        this.notifyService.warning(`Please enter interpretation text for template ${template.templateName}`);
                        throw BreakError;
                    }
                }

                template.components.forEach((component: LabComponentHeaderForInput) => {
                    component.parameters.forEach((parameter: LabParameterInputHeaderModel) => {
                        let model = new TempParameter();
                        model.labComponentHeaderId = component.labComponentHeaderId;
                        model.labTemplateHeaderId = template.labTemplateHeaderId;
                        model.templateName = template.templateName;
                        model.labParameterHeaderId = parameter.labParameterHeaderId;
                        model.parameterName = parameter.parameterName;
                        model.referenceOutput = parameter.referenceOutput;
                        if (!UtilHelper.isEmpty(parameter.observedValue)) {
                            this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                            throw BreakError;
                        }
                        else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                            this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> ${component.componentName} <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                            throw BreakError;
                        }
                        model.observedValue = parameter.observedValue;
                        model.labParameterObservedValueId = parameter.labParameterObservedValueId;
                        model.labParameterDetailId = parameter.labParameterDetailId;
                        this.parameterInput.push(model);
                    });
                });

                template.parameters.forEach((parameter: LabParameterInputHeaderModel) => {
                    let model = new TempParameter();
                    model.labComponentHeaderId = 0;
                    model.labTemplateHeaderId = template.labTemplateHeaderId;
                    model.templateName = template.templateName;
                    model.labParameterHeaderId = parameter.labParameterHeaderId;
                    model.parameterName = parameter.parameterName;
                    model.referenceOutput = parameter.referenceOutput;
                    if (!UtilHelper.isEmpty(parameter.observedValue)) {
                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                        throw BreakError;
                    }
                    else if (!UtilHelper.isEmpty(parameter.observedValue.trim())) {
                        this.notifyService.warning(`Please enter value of  ${template.templateName} <i class="mdi mdi-arrow-right"></i> Direct Parameter <i class="mdi mdi-arrow-right"></i> <b>parameter</b> ${parameter.parameterName}`);
                        throw BreakError;
                    }
                    model.observedValue = parameter.observedValue;
                    model.labParameterObservedValueId = parameter.labParameterObservedValueId;
                    model.labParameterDetailId = parameter.labParameterDetailId;
                    this.parameterInput.push(model);
                });

                const templateToPush = {
                    labTemplateObservedValueId: template.labTemplateObservedValueId || 0,
                    newLabBookingDetailId: this.newLabBookingDetailId,
                    labTemplateHeaderId: template.labTemplateHeaderId,
                    isMethod: template.isMethod,
                    methodText: template.methodText,
                    isInterpretation: template.isInterpretation,
                    interpretationText: template.interpretationText,
                    labMainDetailId: this.parameters.labMainDetailId
                };
                if (template.isInterpretation || template.isMethod) {
                    this.templateInput.push(templateToPush);
                }
            });
            this.submitting = true;
            let requestApi = new Array<any>();
            if (this.parameterInput.length > 0) {
                const parameterRequest = {
                    newLabBookingDetailId: this.newLabBookingDetailId,
                    parameters: this.parameterInput,
                    createdBy: this.page.userAccount.accountId
                }
                let parameterApi = this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.addLabParameterInput), parameterRequest);
                requestApi.push(parameterApi);
            }
            if (this.templateInput.length > 0) {
                const templateRequest = {
                    newLabBookingDetailId: this.newLabBookingDetailId,
                    templates: this.templateInput,
                    createdBy: this.page.userAccount.accountId
                }
                let templateApi = this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.addTemplateInput), templateRequest);
                requestApi.push(templateApi);
            }
            //if (this.page.userAccount.roleId == 3) {
            //    let doctorVerifyApi = this.httpService.post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.doctorVerifyReport), req2);
            //    requestApi.push(doctorVerifyApi);
            //}
            forkJoin([...requestApi])
                .pipe(takeUntil(this.page.unSubscribe))
                .pipe(finalize(() => this.submitting = false))
                .subscribe((response: Array<any>) => {
                    if (response[0] as number > 0 && response[1] as number > 0) {
                        this.notifyService.successToast("Labs Parameters and Templates added successfully.");
                    }
                    else if (response[0] as number > 0) {
                        this.notifyService.successToast("Labs Parameters modified successfully.");
                    }
                    else if (response[1] as number > 0) {
                        this.notifyService.successToast("Labs Templates modified successfully.");
                    }
                    if (!this.isVerify) {
                        this.onCloseModel();
                    } else {
                        this.onVerifyByTechnician();
                        this.isVerify = false;
                    }
                }, () => {
                    this.notifyService.defaultErrorToast();
                });
        } catch (err) {
            if (err !== BreakError) throw err;
        }

    }

    private fetchTimeline() {
        const request = {
            newLabBookingHeaderId: "",
            newLabBookingDetailId: this.newLabBookingDetailId
        };
        this.loadingTimeline = true;
        this.httpService.get(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchLabTimeline), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingTimeline = false))
            .subscribe((response: Array<LabStatusModel>) => {
                this.timeline = response;
            }, () => {
                this.notifyService.warningToast("Unable to fetch lab timeline.");
            });
    }

    onOpenForParameterSelection(content: TemplateRef<any>, data: LabParameterInputHeaderModel) {
        this.selectedParameter = data;
        this.onOpenModel(content, "xl");
    }

    onSelectParameter(selectedValue: LabParameterGroup) {
        this.selectedParameter.labParameterDetailId = selectedValue.labParameterDetailId;
        this.selectedParameter.selected = selectedValue;
        this.onCloseModal();
    }

    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    this.onFetchInputParameters();
                    this.onFetchDemographData();
                    this.fetchTimeline();
                    this.fetchNewLabBookingDetail();
                } else {
                    this.page.userAccount = undefined;
                }
            });
    }

    onOpenModel(content: TemplateRef<any>, size: string) {
        this.modalRef = this.modalService.open(content, {
            backdrop: "static",
            keyboard: false,
            centered: false,
            size: size,
            windowClass: "custom-modal effect-scale"
        });
    }

    onCloseModal() {
        try {
            this.modalRef.close();
            this.modalRef = undefined;
            this.totalObservedValues2 = null;
            this.totalObservedValues = null;

        } catch (e) {
            // ignored;
        }
         this.isVerify = false;
    }

    ngOnDestroy() {
        this.onCloseExtraPopup();
        this.onCloseModal();
        this.onCloseModel();
        this.page.unsubscribeAll();
    }

    onViewReport(content: TemplateRef<any>) {
        this.reports = new LabParameterInputModel();
        this.reports = UtilHelper.clone(this.parameters);
        this.reports.templates = new Array<LabTemplateHeaderForInput>();
        this.parameters.templates.forEach((template: LabTemplateHeaderForInput) => {
            let parameterList = new Array<LabParameterInputHeaderModel>();
            template.components.forEach((component: LabComponentHeaderForInput) => {
                component.parameters.forEach((param: LabParameterInputHeaderModel) => {
                    parameterList.push(param);
                });
            });
            template.parameters.forEach((param: LabParameterInputHeaderModel) => {
                parameterList.push(param);
            });
            let templateToAssign = UtilHelper.clone(template) as LabTemplateHeaderForInput;

            templateToAssign.components = new Array<LabComponentHeaderForInput>();
            templateToAssign.parameters = new Array<LabParameterInputHeaderModel>();
            LinqHelper.sort(parameterList, "displayOrder");
            templateToAssign.parameters = parameterList;
            this.reports.templates.push(templateToAssign);
        });

        this.onOpenModel(content, "xl");
        this.currentDate = new Date();
        this.loadingDoctorSignatures = true;
        this.httpService.get(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchDoctorSignature), { newLabBookingDetailId: this.newLabBookingDetailId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingDoctorSignatures = false))
            .subscribe((response: Array<LabReportSignature>) => {
                response.forEach(x => {
                    x["newSignature"] = x.signature ? this.safe(x.signature) : null;
                })
                this.reportSignatures = response;
                //this.router.navigate([]).then(() => { window.open(`${location.origin}${location.pathname}#/app/labs/patient-lab-report/${this.newLabBookingDetailId}`, "_blank"); });
                //This Below one will Work.
                //this.router.navigate([]).then(() => { window.open(`${location.origin}${location.pathname}#/new-lab-reports/${this.newLabBookingDetailId}`, "_blank"); });
            }, () => {
                this.notifyService.warningToast("Unable to Doctor signature.");
            });

    }
    fetchProviders() {
        this.loadingProviders = true;
        this.resourceService.pathologyProviders()
            .pipe(finalize(() => { this.loadingProviders = false }))
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((response: Array<IResource>) => {
                this.providers = response;
            });
    }
    selectDoctor(content: TemplateRef<any>) {
        this.onOpenModel(content, "xl");
        this.fetchProviders();
        this.buildProviderAssigningForm();
        if (this.demographData[0].status != "Verified") {
            this.doctorDropDown = true;
        }
        else {
            this.doctorDropDown = false;
        }
        setTimeout(() => {
            this.callwhenAfterProvidersLoaded();
        }, 1000)


    }
    callwhenAfterProvidersLoaded() {
        if (this.demographData[0].status == "Verified" || this.demographData[0].status == "DoctorAssigned" || this.demographData[0].status == "DoctorVerified" || this.demographData[0].status == "RemovedDoctor") {
            this.provideredit = true;
            this.httpService.get(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchDoctorsAssigned), { newLabBookingDetailId: this.newLabBookingDetailId })
                .pipe(takeUntil(this.page.unSubscribe))
                .pipe(finalize(() => this.loadingDoctorSignatures = false))
                .subscribe((response: any) => {
                    this.providerAssigned = response;
                    for (let i = 0; i < response.length; i++) {
                        var result = this.providers.filter(item => item.id != response[i].approvedBy);
                        this.providers = result;
                    }

                    //var result = this.providers.filter(item => item.id != response[0].approvedBy);
                    //let abc = response.map(x => x.approvedBy)
                    //this.providerAssigningForm.get("approvedBy").setValue(abc);
                    //this.providers = result;
                });
        }
        else {
            this.provideredit = false;
        }
    }
    private buildProviderAssigningForm() {
        this.providerAssigningForm = this.formBuilder.group({
            approvedBy: [null, [Validators.required]],
            departmentId: [null],
            specializationId: [null],
            providerLocationId: [null],
            locationIds: [null],
            labReportVerificationId: 0
        })
        //if (this.providerAssigned != null || this.providerAssigned != undefined) {
        //    for (let i = 0; i < this.providerAssigned.length; i++) {
        //        this.providerAssigningForm.patchValue({
        //            approvedBy: this.providerAssigned[i].providerId,
        //        });
        //    }
        //}


        //this.providerAssigningForm.get("locationIds").valueChanges.subscribe((value: number) => {
        //    if (value) {
        //        this.fetchDoctorSpecialization(null, value)
        //        this.providerAssigningForm.get("specializationId").setValue(null);
        //    }
        //})

    }

    private buildTechForm(id: number) {
        this.techForm = this.formBuilder.group({
            technicianId: this.page.userAccount.accountId,
            newLabBookingDetailId: id,
            technicianComment: [null, [Validators.required]]
        })
    }

    get forms() {
        return {
            //popUp: this.popUpForm ? this.popUpForm.controls : {},
            providerSchedule: this.providerAssigningForm ? this.providerAssigningForm.controls : {},
            tech: this.techForm ? this.techForm.controls : {},
            //reschedulePopUp: this.reschedulePopUpForm ? this.reschedulePopUpForm.controls : {}
        }
    }
    customSearch(term: string, item) {
        term = term.toLocaleLowerCase();
        return item['value'].toLocaleLowerCase().indexOf(term) > -1 || item['optionalText'].toLocaleLowerCase().indexOf(term) > -1;
    }
    fetchDoctorSpecializationHelper($event: any) {
        if ($event && $event.term && $event.term.length >= 2) {
            let locationId = this.providerAssigningForm.get("locationIds").value
            this.fetchDoctorSpecialization($event.term, locationId);
        } else {
            this.providerSpecialization = new Array<ProviderSpecialization>();
        }
    }
    private fetchDoctorSpecialization(providerId?: string, locationId?: number) {
        this.loading = true;
        var request = {
            filter: providerId,
            locationId: locationId
        }

        this.httpService
            .post<Array<ProviderSpecialization>>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.fetchDoctorSpecialization), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loading = false))
            .subscribe(
                (response: Array<ProviderSpecialization>) => {
                    this.providerSpecialization = response;
                },
                () => {
                    this.providerSpecialization = new Array<ProviderSpecialization>();
                }
            );
    }
    onChangeProvider(event: any) {

        if (event.length >= 1) {
            //const res = event.map((id) => this.providerSpecialization.find((o) => o.specializationId === id));
            let result = event.map(a => a.id);
            //var specialization = value.forEach(x => { x = this.providerSpecialization.find(m => m.specializationId = x) })
            this.providerAssigningForm.get("approvedBy").setValue(result);
            //this.fetchProviderSchedule();
            //this.draggableEvent = true;
        }
        else {
            //window.location.reload();
            this.notifyService.warningToast("Please select provider");
            //this.fullcalendar.calendar.destroy();

            //this.calendarOptions = undefined;
        }
        //this.providerId = event.providerId;
        //this.providerScheduleForm.patchValue({
        //    departmentId: event.departmentId,
        //    specializationId: event.specializationId
        //});
    }
    assignDoctors() {
        if (!this.providerAssigningForm.valid) {
            this.notifyService.warningToast("Please Select Doctor");
            return;
        }
        this.loadingproviderAssigning = true;
        const request = this.providerAssigningForm.getRawValue();
        request["newLabBookingDetailId"] = this.newLabBookingDetailId;
        request["Active"] = false;
        request["createdBy"] = this.page.userAccount.accountId;
        this.httpService
            .post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.assignToDoctor), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingproviderAssigning = false))
            .subscribe(
                (response: number) => {
                    if (response >= 0) {
                        this.doctorAssigned = true;
                        this.notifyService.successToast("Assigned to respective Doctor's");
                        this.onCloseModal();
                        this.fetchTimeline();
                        this.onFetchDemographData();
                    }
                    else {
                        this.notifyService.warningToast("There is an error in Assigning to doctor");
                    }
                },
                () => {
                    //this.providerSpecialization = new Array<ProviderSpecialization>();
                }
            );

    }

    onRemove(event: any) {
        if (this.demographData[0].status == "Verified" || this.demographData[0].status == "DoctorAssigned" || this.demographData[0].status == "DoctorVerified") {
            this.providers.push(event.value.id);
            //this.providers = [...this.providers];
            //if (this.providers.some((condition) => condition == event.value.id)) {
            //    console.log('adding back');
            //    this.providers.push(event.value);
            //    this.providers = [...this.providers];
            //}
        }
    }
    
    onDeleteAssignedDoctor(provider: LabReportSignature) {
        const request = {
            labReportVerificationId: provider.labReportVerificationId,
            createdBy: this.page.userAccount.accountId,
            status: this.demographData[0].status,
            testName: this.demographData[0].testName,
            newLabBookingDetailId: this.newLabBookingDetailId
        };
        if (!request.labReportVerificationId || !request.createdBy || !request.status || !request.testName || !request.newLabBookingDetailId) {
            return this.notifyService.warningToast("Please Select Provider to delete The Assignment of that Lab Report");
        }
        this.httpService
            .post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.removeDoctor), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingproviderAssigning = false))
            .subscribe(
                (response: number) => {
                    if (response >= 0) {
                        this.notifyService.successToast("Removed Doctor Assignment for this Lab Report Succesfully");
                        this.onCloseModal();
                        this.fetchTimeline();
                        this.onFetchDemographData();
                    }
                    else {
                        this.notifyService.warningToast("There is an error in removing the doctor");
                    }
                },
                () => {
                    //this.providerSpecialization = new Array<ProviderSpecialization>();
                }
            );

    }
    viewPreviousResultsAdded(content: TemplateRef<any>) {
        var start = 0;
        var arr2 = []

        this.loadingObservedValues = true;
        const request = {
            newLabBookingDetailId: this.newLabBookingDetailId
        };
        this.httpService
            .post(ApiResources.getURI(ApiResources.labs.base, ApiResources.labs.fetchallobservedvalues), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingObservedValues = false))
            .subscribe(
                (response: Array<LabObservedValueModel>) => {
                    this.totalObservedValues = response;
                    const distinctThings = this.totalObservedValues.filter(
                        (zzzz, i, arr) => arr.findIndex(t => t.parameterName === zzzz.parameterName) === i
                    );
                    this.parameterNames = distinctThings;
                    var end = this.totalObservedValues[0].count;
                    var count = this.totalObservedValues[0].count;
                    for (let i = 0; i < this.totalObservedValues.length / count; i++) {
                        arr2.push(this.totalObservedValues.slice(start, end))
                        start = end;
                        end = end + count;
                    }
                    this.totalObservedValues2 = arr2;
                },
                () => {
                    this.totalObservedValues = new Array<LabObservedValueModel>();
                    this.loadingObservedValues = false
                }
            );
        this.onOpenModel(content, "xl");
    }
    onViewReportNew(content: TemplateRef<any>) {
        this.showLabReport = true;
        this.onOpenModel(content, "xl");
        this.currentDate = new Date();
    }
    onCloseExtraPopup() {
        this.showLabReport = false;
        try {
            this.modalRef.close();
            this.modalRef = undefined;
            this.totalObservedValues2 = null;
            this.totalObservedValues = null;

        } catch (e) {
            // ignored;
        }
    }

    onOpenUploadFile(content: TemplateRef<any>/*, recordDetail: LabBillDetailModel*/) {
        this.onOpenModel(content, "xl");
        this.onResetFileUploader();
        //this.selectedLabBookingDetail = recordDetail;
    }
    onResetFileUploader() {
        this.loadingFile = false;
        this.documentError = false;
        this.fileName = null;
        this.formedUrl = null;
        this.uploadedFile = null;
        this.fileUploadFail = false;
    }

    onUploadReport() {
        const request = {
            ...this.selectedLabBookingDetail,
            uploadedBy: this.page.userAccount.accountId
        };
        request["roleId"] = this.page.userAccount.roleId;
        request["createdByName"] = this.page.userAccount.fullName;
        request["requisitionNumber"] = this.demographData[0].requisitionNumber;
        const formData = UtilHelper.prepareFormData(UtilHelper.clone(request));
        formData.append(`File${1}`, this.uploadedFile, this.uploadedFile.name);
        this.isUploading = true;
        this.httpService.postFile(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.uploadLabData), formData)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => {
                this.isUploading = false;
                this.onCloseModal();
            }))
            .subscribe((res: string) => {
                this.notifyService.successToast(res);
                //this.fetchLabsBooked();
                this.onResetFileUploader();
                //this.selectedLabBookingDetail = new LabBillDetailModel();
            }, (error: HttpErrorResponse) => {
                const errorMessage = UtilHelper.handleError(error);
                if (errorMessage) {
                    this.notifyService.warningToast(errorMessage);
                } else {
                    this.notifyService.defaultError();
                }
            });
    }

    private fetchNewLabBookingDetail() {
        this.loadingTimeline = true;
        this.httpService.get(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.fetchNewLabBookingDetail), { newLabBookingDetailId: this.newLabBookingDetailId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.loadingTimeline = false))
            .subscribe((response: LabBillDetailModel) => {
                this.selectedLabBookingDetail = response;
            }, () => {
                this.notifyService.warningToast("Unable to fetch lab Booking detail.");
            });
    }

    onFileUpload(event) {
        this.loadingFile = true;
        this.uploadedFile = event.target.files[0];
        this.fileUploadFail = false;
        this.fileName = this.uploadedFile.name;
        let extension = this.uploadedFile.name.split(".").pop();
        if (extension === "pdf") {
            this.fileChangeEvent();
        }
        else {
            this.loadingFile = false;
            this.uploadedFile = null;
            this.fileUploadFail = true;
        }
    }

    fileChangeEvent() {
        function getBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        }


        getBase64(this.uploadedFile).then((data: any) => {
            this.formedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data);
            this.loadingFile = false;
        }, () => {
            this.uploadedFile = null;
            this.fileUploadFail = true;
            this.loadingFile = false;
            this.formedUrl = null;
        });
    }

    onProgress(progressData: ProgressData) {
        if (progressData.loaded === progressData.total) {
            this.loadingFile = false;
        }
    }

    onDocumentError() {
        this.loadingFile = false;
        this.documentError = true;
    }

    onOpenTechForm(content: TemplateRef<any>) {
        if (this.demographData[0].assignDoctorRequired && !this.doctorAssigned) {
            this.notifyService.info("For this Test Assign Doctor is required", () => {

            });
        }
        else {
            this.buildTechForm(this.selectedLabBookingDetail.newLabBookingDetailId);
            this.onOpenModel(content, "lg");
        }
        
        
    }

    onVerifyByTechnician() {
        this.submitted = true;

        const req = this.techForm.getRawValue();
        req["roleId"] = this.page.userAccount.roleId;
        req["createdByName"] = this.page.userAccount.fullName;
        req["testName"] = this.demographData[0].testName;
        req["requisitionNumber"] = this.demographData[0].requisitionNumber;
        this.submitting = true;

        this.httpService.post(ApiResources.getURI(ApiResources.labTransaction.base, ApiResources.labTransaction.addTechnicianVerification), req)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.submitted = this.submitting = false))
            .subscribe((response: number) => {
                if (response > 0) {
                    this.notifyService.successToast("Lab technician verified successfully.");
                    this.onCloseModal();
                    this.fetchTimeline();
                    this.fetchNewLabBookingDetail();
                }
            }, () => {
                this.notifyService.warningToast("Unable to verify.");
            });

    }

    onSubmitVerify() {
        this.isVerify = true;
        this.onSubmit();
    }
    changeTextColor(param: LabParameterInputHeaderModel) {
        let observedValue = +param.observedValue;
        let range = param.selected;
        if (range != null) {
            let exactRange = range;
            param.showText = null;
            param.isBold = false;
            if (exactRange.minValue > observedValue) {
                param.showText = "L";
                param.isBold = true;
            }
            else if (observedValue > +exactRange.maxValue) {
                param.showText = "H";
                param.isBold = true;
            }
        }
    }
}